import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useAuth } from "../login/AuthProvider";
import { dateHelper } from "../../modules/helpers";
import FileIcon from "../../components/file_icon";
import {
  userfiles,
  userfiles_memberUpload,
  userfiles_teacherUpload,
  userfiles_notes_list,
  userfiles_notes_create,
  userfiles_notes_update,
  userfiles_notes_delete,
} from "../../components/apipath";

/* ===========================
   🔹 外層元件：NotesCard
   =========================== */
function NotesCard({
  noteType, setNoteType,
  noteRef, noteLen, setNoteLen,
  isComposing, setIsComposing,
  editingId, saving,
  onSave, onCancel, onEdit, onDelete,
  notes, dateHelper,
}) {
  return (
    <div className="col-12">
      <div className="card" id="notes">
        <div className="card-header bg-dark text-light">
          <div className="card-title">
            <h4 className="p-0 m-0">內部備註（學歷認證 / 報考流程 / 一般）</h4>
          </div>
        </div>
        <div className="card-body">
          {/* 新增 / 編輯 表單 */}
          <div className="row g-2 align-items-start">
            <div className="col-12 col-md-3">
              <label className="form-label">備註類型</label>
              <select
                className="form-select form-select-sm"
                value={noteType}
                onChange={(e) => setNoteType(e.target.value)}
              >
                <option value="academic">學歷認證</option>
                <option value="exam">報考流程</option>
                <option value="general">一般備註</option>
              </select>
            </div>

            <div className="col-12">
              <label className="form-label">備註內容</label>
              <textarea
                ref={noteRef}
                className="form-control"
                rows={3}
                maxLength={4000}
                placeholder="請輸入內部備註（不顯示給學員）"
                onInput={(e) => setNoteLen(e.target.value.length)}
                onCompositionStart={() => setIsComposing(true)}
                onCompositionEnd={() => setIsComposing(false)}
                onKeyDown={(e) => {
                  if ((e.ctrlKey || e.metaKey) && e.key === "Enter" && !isComposing) {
                    e.preventDefault();
                    onSave();
                  }
                }}
                autoComplete="off"
              />
              <div className="d-flex justify-content-between mt-2">
                <small className="text-muted">{noteLen}/4000</small>
                <div>
                  {editingId && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={onCancel}
                    >
                      取消編輯
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    disabled={saving}
                    onClick={onSave}
                  >
                    {editingId ? "更新備註" : "新增備註"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <hr />

          {/* 備註歷程列表 */}
          <div className="table-responsive">
            <table className="table table-borderless table-striped table-hover">
              <thead>
                <tr className="text-center">
                  <th style={{ width: 110 }}>類型</th>
                  <th>內容</th>
                  <th style={{ width: 180 }}>建立 / 更新</th>
                  <th style={{ width: 140 }}>建立者</th>
                  <th style={{ width: 140 }}>操作</th>
                </tr>
              </thead>
              <tbody>
                {(notes || []).map((n) => {
                  const typeLabel =
                    n.note_type === "academic"
                      ? "學歷認證"
                      : n.note_type === "exam"
                      ? "報考流程"
                      : "一般";
                  return (
                    <tr key={n.id}>
                      <td className="text-center">
                        <span className="badge bg-secondary">{typeLabel}</span>
                      </td>
                      <td style={{ whiteSpace: "pre-wrap" }}>{n.content}</td>
                      <td className="text-center">
                        <div>{n.created_at ? dateHelper(n.created_at, "datetime") : "—"}</div>
                        <small className="text-muted">
                          {n.updated_at ? `更新：${dateHelper(n.updated_at, "datetime")}` : ""}
                        </small>
                      </td>
                      <td className="text-center">{n.created_name || "—"}</td>
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={() => onEdit(n)}
                        >
                          編輯
                        </button>
                        {/* <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => onDelete(n.id)}
                        >
                          刪除
                        </button> */}
                      </td>
                    </tr>
                  );
                })}
                {(!notes || notes.length === 0) && (
                  <tr>
                    <td colSpan={5} className="text-center text-muted">
                      尚無備註
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ===========================
   🔹 外層元件：FileCard
   =========================== */
function FileCard({
  id, title, headerClass, type,
  fileData, dateHelper, FileIcon,
  handleInputChange, upload, handleDelete
}) {
  return (
    <div className="col-12">
      <div className="card" id={id}>
        <div className={`card-header ${headerClass || ""}`}>
          <div className="card-title">
            <h4 className="p-0 m-0">{title}</h4>
          </div>
        </div>
        <div className="card-body table-responsive">
          <div className="input-group input-group-sm">
            <span className="input-group-text">新增檔案</span>
            <input
              type="file"
              name={type}
              className="form-control form-control-sm"
              onChange={handleInputChange}
            />
            <button type="button" className="btn btn-sm btn-primary" onClick={() => upload(type)}>
              上傳
            </button>
          </div>
          <hr />
          <table className="table table-borderless table-striped table-hover">
            <thead>
              <tr className="text-center">
                <th>名稱</th>
                <th>大小</th>
                <th>上傳日期</th>
                <th>上傳者</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {(fileData?.[type] || []).map((file) => (
                <tr key={file.id}>
                  <td>
                    <div className="text-nowrap">
                      {FileIcon(file.file_extension)}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={file.file_url}
                        className="btn btn-sm btn-outline-primary"
                      >
                        {file.file_name}
                      </a>
                    </div>
                  </td>
                  <td className="text-center">
                    {`${Math.round(((file.file_size / 1024 / 1024) * 100)) / 100} MB`}
                  </td>
                  <td className="text-center">{dateHelper(file.file_date, "datetime")}</td>
                  <td className="text-center">{(file.upload_person + "").split("|")[1]}</td>
                  <td className="text-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(file.id)}
                    >
                      刪除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/* ===========================
   🔶 主元件：AdmFiles
   =========================== */
function AdmFiles() {
  const { user_type, user_id, tag_id } = useParams();
  const { token } = useAuth();

  /* ----- Files state ----- */
  const [fileData, setFileData] = useState({
    resume: [], transcript: [], interview: [], application: [],
    academic: [], video: [], contract: [], other: [],
  });
  const fileType = ["resume","transcript","interview","video","contract","application","academic","other"];

  const [resume, setResume]         = useState({ file_type: "resume",      file_name: "", file: null });
  const [transcript, setTranscript] = useState({ file_type: "transcript",   file_name: "", file: null });
  const [interview, setInterview]   = useState({ file_type: "interview",    file_name: "", file: null });
  const [video, setVideo]           = useState({ file_type: "video",        file_name: "", file: null });
  const [contract, setContract]     = useState({ file_type: "contract",     file_name: "", file: null });
  const [application, setApplication]=useState({ file_type: "application",  file_name: "", file: null });
  const [academic, setAcademic]     = useState({ file_type: "academic",     file_name: "", file: null });
  const [other, setOther]           = useState({ file_type: "other",        file_name: "", file: null });

  /* ----- Notes state (uncontrolled textarea) ----- */
  const noteRef = useRef(null);
  const [noteLen, setNoteLen] = useState(0);
  const [noteType, setNoteType] = useState("academic"); // academic/exam/general
  const [notes, setNotes] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [isComposing, setIsComposing] = useState(false);

  /* ----- Fetchers ----- */
  const fetchData = async () => {
    try {
      const response = await axios.get(`${userfiles}${user_type}/${user_id}`, { headers: { token } });
      const buckets = { resume:[], transcript:[], interview:[], video:[], contract:[], application:[], academic:[], other:[] };
      for (const item of response.data?.data || []) {
        if (buckets[item.file_type]) buckets[item.file_type].push(item);
      }
      setFileData(buckets);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchNotes = async () => {
    try {
      const res = await axios.get(userfiles_notes_list(user_type, user_id), {
        headers: { token, "Cache-Control": "no-cache" },
        params: { _t: Date.now() },
      });
      if (res.data?.status === 200) setNotes(res.data.data || []);
      else setNotes([]);
    } catch (e) {
      console.error(e);
      setNotes([]);
    }
  };

  /* ----- Notes handlers ----- */
  const handleSaveNote = async () => {
    const content = (noteRef.current?.value || "").trim();
    if (!content) { alert("請輸入備註內容"); return; }
    setSaving(true);
    try {
      if (editingId) {
        const res = await axios.put(
          userfiles_notes_update(editingId),
          { content, note_type: noteType },
          { headers: { token } }
        );
        if (res.data?.status !== 200) throw new Error(res.data?.msg || "更新失敗");
      } else {
        const res = await axios.post(
          userfiles_notes_create,
          { user_type, user_id: +user_id, note_type: noteType, content },
          { headers: { token } }
        );
        if (res.data?.status !== 200) throw new Error(res.data?.msg || "新增失敗");
      }
      // reset
      if (noteRef.current) noteRef.current.value = "";
      setNoteLen(0);
      setNoteType("academic");
      setEditingId(null);
      await fetchNotes();
    } catch (e) {
      console.error(e);
      alert(e.message || "儲存失敗");
    } finally {
      setSaving(false);
    }
  };

  const handleEditNote = (note) => {
    setEditingId(note.id);
    setNoteType(note.note_type);
    if (noteRef.current) {
      noteRef.current.value = note.content || "";
      setNoteLen((note.content || "").length);
      noteRef.current.focus();
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setNoteType("academic");
    if (noteRef.current) { noteRef.current.value = ""; setNoteLen(0); }
  };

  const handleDeleteNote = async (id) => {
    if (!window.confirm("確定刪除此備註？")) return;
    try {
      const res = await axios.delete(userfiles_notes_delete(id), { headers: { token } });
      if (res.data?.status !== 200) throw new Error(res.data?.msg || "刪除失敗");
      await fetchNotes();
    } catch (e) {
      console.error(e);
      alert(e.message || "刪除失敗");
    }
  };

  /* ----- Files handlers ----- */
  const upload = async (type) => {
    try {
      const stateMap = { resume, transcript, interview, video, contract, application, academic, other };
      const state = stateMap[type];
      if (!state) { alert("未知的檔案類型"); throw new Error("Unknown file_type"); }
      const uploadData = { ...state, user_id, user_type };
      if (!fileType.includes(uploadData.file_type) || !uploadData.file) {
        alert("請選擇檔案!");
        throw new Error("File not exists or wrong file type.");
      }
      const uploadUrl = user_type === "teacher" ? userfiles_teacherUpload : userfiles_memberUpload;
      const response = await axios.post(uploadUrl, uploadData, {
        headers: { token, "Content-Type": "multipart/form-data" },
      });
      if (response.data.status !== 200) throw new Error(response.data.msg);

      // reset all file inputs
      setResume({ file_type: "resume", file_name: "", file: null });
      setTranscript({ file_type: "transcript", file_name: "", file: null });
      setInterview({ file_type: "interview", file_name: "", file: null });
      setVideo({ file_type: "video", file_name: "", file: null });
      setContract({ file_type: "contract", file_name: "", file: null });
      setApplication({ file_type: "application", file_name: "", file: null });
      setAcademic({ file_type: "academic", file_name: "", file: null });
      setOther({ file_type: "other", file_name: "", file: null });

      await fetchData();
      document.getElementsByName(type).forEach((f) => (f.value = ""));
    } catch (error) {
      console.error(error);
      alert("上傳失敗，請見 console log");
    }
  };

  const handleDelete = async (file_id) => {
    try {
      const confirm = window.confirm("確認刪除 ?");
      if (confirm) {
        const response = await axios.delete(`${userfiles}admin/${file_id}`, { headers: { token } });
        if (response.data.status !== 200) throw new Error(response.data.msg);
        fetchData();
      }
    } catch (error) {
      alert("刪除失敗，請見 Log");
      console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name } = e.target;
    const value = e.target.value;
    const file = e.target.files?.[0] ?? null;
    const map = {
      resume: [setResume, resume],
      transcript: [setTranscript, transcript],
      interview: [setInterview, interview],
      video: [setVideo, video],
      contract: [setContract, contract],
      application: [setApplication, application],
      academic: [setAcademic, academic],
      other: [setOther, other],
    };
    if (map[name]) {
      const [setter, state] = map[name];
      setter({ ...state, file_name: value, file });
    }
  };

  /* ----- Effects ----- */
  useEffect(() => {
    fetchData();
    fetchNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_type, user_id]);

  useEffect(() => {
    const targetScroll = document.getElementById(tag_id);
    if (targetScroll) targetScroll.scrollIntoView(true, { block: "start", inline: "nearest" });
  }, [tag_id]);

  /* ----- Render ----- */
  return (
    <>
      <div className="container" style={{ marginTop: "50px" }}>
        {/* 內部備註：member/teacher 都顯示 */}
        <div className="row g-5">
          <NotesCard
            noteType={noteType}
            setNoteType={setNoteType}
            noteRef={noteRef}
            noteLen={noteLen}
            setNoteLen={setNoteLen}
            isComposing={isComposing}
            setIsComposing={setIsComposing}
            editingId={editingId}
            saving={saving}
            onSave={handleSaveNote}
            onCancel={handleCancelEdit}
            onEdit={handleEditNote}
            onDelete={handleDeleteNote}
            notes={notes}
            dateHelper={dateHelper}
          />
        </div>

        <div className="row g-5">
          <FileCard
            id={`${user_type === "member" ? "m" : "t"}Resume`}
            title="履歷"
            headerClass="bg-success text-light"
            type="resume"
            fileData={fileData}
            dateHelper={dateHelper}
            FileIcon={FileIcon}
            handleInputChange={handleInputChange}
            upload={upload}
            handleDelete={handleDelete}
          />

          {user_type === "member" && (
            <>
              <FileCard id="mTranscript" title="成績單" headerClass="bg-warning" type="transcript"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
              <FileCard id="mInterview" title="諮詢紀錄" headerClass="bg-info" type="interview"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
              <FileCard id="mApplication" title="報考文件" headerClass="bg-primary text-light" type="application"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
              <FileCard id="mAcademic" title="學歷認證" headerClass="bg-secondary text-light" type="academic"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
              <FileCard id="mOther" title="其他" type="other"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
            </>
          )}

          {user_type === "teacher" && (
            <>
              <FileCard id="tVideo" title="試教影片" headerClass="bg-warning" type="video"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
              <FileCard id="tContract" title="合約" headerClass="bg-info" type="contract"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
              <FileCard id="tOther" title="其他" type="other"
                        fileData={fileData} dateHelper={dateHelper} FileIcon={FileIcon}
                        handleInputChange={handleInputChange} upload={upload} handleDelete={handleDelete} />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default AdmFiles;
